function ContentSection({ sections }) {
  return (
    <section className="py-10 sm:py-[60px] bg-dark">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {sections.map((s, i) => (
          <div key={i} className="mb-16 last:mb-0">
            <h2 className={`font-playfair text-3xl sm:text-4xl font-bold mb-6 ${s.titleColor ? '' : 'gold-gradient-text'}`} style={s.titleColor ? { color: s.titleColor } : undefined}>{s.title}</h2>
            {s.paragraphs.map((p, j) => (
              <p key={j} className="font-montserrat text-lg sm:text-xl text-white/65 leading-relaxed mb-5">{p}</p>
            ))}
            {s.list && (
              <ul className="space-y-3 mt-4">
                {s.list.map((item, k) => (
                  <li key={k} className="flex items-start space-x-3">
                    <span className="text-gold mt-1">&#9670;</span>
                    <span className="font-montserrat text-lg text-white/60">{item}</span>
                  </li>
                ))}
              </ul>
            )}
            {s.image && (
              <img src={s.image} alt={s.imageAlt || ''} className="w-full mt-8 gold-border object-cover max-h-96" loading="lazy" />
            )}
          </div>
        ))}
      </div>
    </section>
  );
}

export default ContentSection;
